/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Gold_Seal_BeamInputs */

const en_free_gold_seal_beam = /** @type {(inputs: Free_Gold_Seal_BeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows per page`)
};

const de_free_gold_seal_beam = /** @type {(inputs: Free_Gold_Seal_BeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einträge pro Seite`)
};

/**
* | output |
* | --- |
* | "Rows per page" |
*
* @param {Free_Gold_Seal_BeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const free_gold_seal_beam = /** @type {((inputs?: Free_Gold_Seal_BeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Gold_Seal_BeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_free_gold_seal_beam(inputs)
	return de_free_gold_seal_beam(inputs)
});